module.exports = __webpack_public_path__ + "static/media/sporttechx-logo.7022c2fe.png";